import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const GoogleAddressPrompt = () => {
  const [addressData, setAddressData] = useState({
    name: '',
    locality: '',
    subLocality: '',
    district: '',
    pincode: '',
    phone: '',
  });
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const handleAddressChange = (e) => {
    setAddressData({ ...addressData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: '' });
  };

  const validateAddressForm = () => {
    const newErrors = {};
    if (!addressData.name.trim()) newErrors.name = 'Name is required';
    if (!addressData.locality.trim()) newErrors.locality = 'Locality is required';
    if (!addressData.district.trim()) newErrors.district = 'District is required';
    if (!addressData.pincode.match(/^\d{6}$/)) newErrors.pincode = 'Pincode must be 6 digits';
    if (!addressData.phone.match(/^\d{10}$/)) newErrors.phone = 'Phone must be 10 digits';
    return newErrors;
  };

  const handleAddressSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateAddressForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    try {
      await axios.post(
        `${API_BASE_URL}/api/auth/add-address`,
        addressData,
        { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
      );
      setAddressData({ name: '', locality: '', subLocality: '', district: '', pincode: '', phone: '' });
      navigate('/');
    } catch (err) {
      setErrors({ form: err.response?.data?.message || 'Failed to save address.' });
    }
  };

  return (
    <div className="container-fluid bg-light min-vh-100 d-flex justify-content-center align-items-center">
      <div className="card shadow-lg border-0 p-4 w-100" style={{ maxWidth: '420px' }}>
        <div className="card-header  text-dark  text-center">
          <i className="bi bi-leaf-fill me-2"></i>
          <h4 className="mb-0 fw-bold">Welcome!</h4>
        </div>
        <div className="card-body">
          <p className="text-muted small mb-3">Please provide your address details to continue.</p>

          {errors.form && (
            <div className="alert alert-danger" role="alert">
              {errors.form}
            </div>
          )}

          <form onSubmit={handleAddressSubmit}>
            <div className="mb-3">
              <label className="form-label fw-semibold">Name</label>
              <input
                type="text"
                name="name"
                className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                value={addressData.name}
                onChange={handleAddressChange}
              />
              {errors.name && <div className="invalid-feedback">{errors.name}</div>}
            </div>

            <div className="mb-3">
              <label className="form-label fw-semibold">Locality</label>
              <input
                type="text"
                name="locality"
                className={`form-control ${errors.locality ? 'is-invalid' : ''}`}
                value={addressData.locality}
                onChange={handleAddressChange}
              />
              {errors.locality && <div className="invalid-feedback">{errors.locality}</div>}
            </div>

            <div className="mb-3">
              <label className="form-label fw-semibold">Sub-Locality / Road (Optional)</label>
              <input
                type="text"
                name="subLocality"
                className="form-control"
                value={addressData.subLocality}
                onChange={handleAddressChange}
              />
            </div>

            <div className="mb-3">
              <label className="form-label fw-semibold">District</label>
              <input
                type="text"
                name="district"
                className={`form-control ${errors.district ? 'is-invalid' : ''}`}
                value={addressData.district}
                onChange={handleAddressChange}
              />
              {errors.district && <div className="invalid-feedback">{errors.district}</div>}
            </div>

            <div className="mb-3">
              <label className="form-label fw-semibold">Pincode</label>
              <input
                type="text"
                name="pincode"
                className={`form-control ${errors.pincode ? 'is-invalid' : ''}`}
                value={addressData.pincode}
                onChange={handleAddressChange}
              />
              {errors.pincode && <div className="invalid-feedback">{errors.pincode}</div>}
            </div>

            <div className="mb-3">
              <label className="form-label fw-semibold">Phone Number</label>
              <input
                type="text"
                name="phone"
                className={`form-control ${errors.phone ? 'is-invalid' : ''}`}
                value={addressData.phone}
                onChange={handleAddressChange}
              />
              {errors.phone && <div className="invalid-feedback">{errors.phone}</div>}
            </div>

            <button type="submit" className="btn btn-success w-100 mt-3 py-2">
              Save Address
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default GoogleAddressPrompt;
